import { render, staticRenderFns } from "./VCoupon.vue?vue&type=template&id=27b21f3c&scoped=true&"
import script from "./VCoupon.vue?vue&type=script&lang=ts&"
export * from "./VCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./VCoupon.vue?vue&type=style&index=0&id=27b21f3c&lang=scss&scoped=true&"
import style1 from "./VCoupon.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b21f3c",
  null
  
)

export default component.exports